<script setup lang="ts">
defineEmits<{
  shareImage: [item?: GalleryItem];
  likeImage: [item?: GalleryItem];
  zoomImage: [item?: GalleryItem];
}>();

const props = defineProps<{ post: PostItem }>();

const imageData = computed(() =>
  props.post.cover?.file?.id
    ? {
        provider: "directus",
        src:
          props.post.cover.file.id +
          (props.post.cover.file.filename_download
            ? "/" + encodeURIComponent(props.post.cover.file.filename_download)
            : ""),
        width: props.post.cover.file.width,
        height: props.post.cover.file.height,
        alt:
          props.post.cover.file.description ||
          props.post.cover.caption ||
          props.post.title,
        caption: props.post.cover.caption,
      }
    : null
);
</script>

<template>
  <div class="post-content-cover select-none">
    <ContentImage
      v-if="imageData"
      v-bind="imageData"
      :image-id="props.post.cover?.id || (props.post.cover as any as string) || undefined"
      :alt="imageData.alt"
      @share="
        () =>
          $emit(
            'shareImage',
            props.post.cover
              ? { collection: 'images', item: props.post.cover }
              : undefined
          )
      "
      @like="
        () =>
          $emit(
            'likeImage',
            props.post.cover
              ? { collection: 'images', item: props.post.cover }
              : undefined
          )
      "
      @zoom="
        () =>
          $emit(
            'zoomImage',
            props.post.cover
              ? { collection: 'images', item: props.post.cover }
              : undefined
          )
      "
      sizes="100vw xs:390px sm:640px md:768px lg:455px xl:640px xxl:880px"
    />
  </div>
</template>
